export class Encoding {
  /*
  * Utility functions that are able to be run in modern browsers
  */
  static decToHex(dec) {
    const s = dec.toString(16)
    return ("0" + s.substring(s.length-2))
  }

  static sha256(str) {
    const encoded_str = new TextEncoder().encode(str);
    return crypto.subtle.digest({ name: "SHA-256" }, encoded_str);
  }

  static generateRandomString(length) {
    const array = new Uint32Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, Encoding.decToHex).join("");
  }

  static base64urlencode(str) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
  }
}
